import { TextOutlineIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from '../../ModificationItem';

export const PreviewTextItem = ({
  edit,
  editTextOld,
  setEditTextOld,
  errorMessageOld,
  editTextNew,
  setEditTextNew,
  errorMessageNew,
  isEditMode,
  setIsEditMode,
}: {
  edit:
    | IDynamicEditData['element']
    | { old: { value: string }; new: { value: string } };
  editTextOld?: string;
  setEditTextOld?: (value: string) => void;
  errorMessageOld?: string;
  editTextNew?: string;
  setEditTextNew?: (value: string) => void;
  errorMessageNew?: string;
  isEditMode?: boolean;
  setIsEditMode?: { set: (value: boolean) => void };
}) => {
  return (
    <ModificationItem>
      <div className="flex w-1/2 gap-3 ">
        <ModificationItem.Icon>
          <TextOutlineIcon size={18} />
        </ModificationItem.Icon>
        <div className="flex w-[200px]">
          <ModificationItem.Text
            label={edit.old.value}
            isEdit={isEditMode}
            editText={editTextOld}
            setEditText={setEditTextOld}
            errorMessage={errorMessageOld}
            setEditMode={setIsEditMode?.set}
          />
        </div>
      </div>
      <ModificationItem.Arrow />
      <div className="flex w-[190px]">
        <ModificationItem.Text
          label={edit.new.value}
          isEdit={isEditMode}
          setEditText={setEditTextNew}
          editText={editTextNew}
          errorMessage={errorMessageNew}
          setEditMode={setIsEditMode?.set}
        />
      </div>
    </ModificationItem>
  );
};
